import{stringPad as r}from"./Util/stringPad.js";var t=function(t,i,o){return void 0===o&&(o=" "),r(t,i,o)+t};export{t as stringPadStart};
//# sourceMappingURL=stringPadStart.js.map
